<template>
  <v-data-table 
  :headers="headers" 
  :items="tasks" 
  :items-per-page-items="[15, 50, 100, -1]"
  :footer-props="{'items-per-page-options': [15, 50, 100, -1] }"
  :items-per-page.sync="paginationActivityCreate.rowsPerPage"
  @pagination="setRowsOnLocalStorage(dataTableActivityCreateTaskId,paginationActivityCreate.rowsPerPage)"
  class="mt-3" >
    <template v-slot:item="props">
      <tr>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.title }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import ActivityTaskStatusIcon from "../../../../../FieldManagement/StatusIcon";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
export default {
  name: "ObjectFormActivityCreateTasksTable",

  components: { ActivityTaskStatusIcon },

  mixins:[managementDatatableMixin],
  props: {
    tasks: {
      type: Array,
      required: true
    }
  },

data() {
    return {
      dataTableActivityCreateTaskId: "dataTableActivityCreateTaskId" ,
      paginationActivityCreate: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableActivityCreateTaskId")
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$i18n.tc("Type", 1), value: "type", width: "30%" },
        { text: this.$i18n.tc("Activity", 1), value: "title" }
      ];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivityCreate/ActivityCreateTasks.vue